/** Window event that KycVaraModalHost listens to. */
export const OPEN_KYC_VARA_EVENT = "kyc-vara:open";

/**
 * Open the KYC VARA modal on top of the current page (the user stays where they are).
 * Use this for every "Verify now" / KYC button instead of navigating to the old KYC page.
 */
export function openKycVerification() {
  window.dispatchEvent(new Event(OPEN_KYC_VARA_EVENT));
}
